export default {
  init() {
    // JavaScript to be fired on all pages
    /* global ajax_object */
    if($('.img-big').length > 0) {
      $('.slider-image .slider-image-single').on('click', function() {
        let img_id = $(this).data('id');

        $.ajax({
          url: ajax_object.ajax_url,
          type: 'POST',
          data: {
            action: 'image_original',
            image_id: img_id,
          },
          success: function(response) {
            if(window.matchMedia('(min-width: 769px)').matches) {
              let classes = $('.aside-image').find('img').attr('class');
              $('.aside-image').fadeOut('fast', function() {
                $('.aside-image').empty().html(response);
                $('.aside-image').find('img').addClass(classes);
              });

              $('.aside-image').fadeIn();
            } else {
              let classes = $('.aside-image-mobile').find('img').attr('class');
              $('.aside-image-mobile').fadeOut('fast', function() {
                $('.aside-image-mobile').empty().html(response);
                $('.aside-image-mobile').find('img').addClass(classes);
              });

              $('.aside-image-mobile').fadeIn();
            }
          },
        });
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-participation.js